import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';
import { trackClientImpression, trackClientContentAction } from '../../analytics/client-event-tracking';

export async function wunderkindScript(buzz) {
  const wunderkindImpression = (message) => {
    if (message.data && message.data === 'Wunderkind Impression') {
      trackClientImpression(buzz, {
        target_content_type: 'buzz',
        item_type: 'button',
        item_name: 'wunderkind',
        unit_type: 'buzz_body',
        unit_name: buzz.id,
        subunit_name: 'wunderkind'
      });
      console.log('Wunderkind Impression Tracked');
      window.removeEventListener('message', wunderkindImpression, false);
    };
  };

  const wunderkindClick = (message) => {
    if (message.data && message.data === 'Wunderkind Click') {
      trackClientContentAction(buzz, {
        target_content_type: 'buzz',
        item_type: 'button',
        item_name: 'wunderkind',
        unit_type: 'buzz_body',
        unit_name: buzz.id,
        subunit_name: 'wunderkind',
        action_type: 'signup',
        action_value: 'wunderkind'
      });
      console.log('Wunderkind Click Tracked');
      window.removeEventListener('message', wunderkindClick, false);
    };
  };

  window.addEventListener('message', wunderkindImpression);
  window.addEventListener('message', wunderkindClick);
  await loadScript(document.location.protocol + '//tag.wknd.ai/4759/i.js');
}
